import { Component, Injector, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    standalone: false,
    selector: 'ep-dynamic-modal-content',
    template: `
    <aurora-icon-button
      *ngIf="showCloseButton"
      type="button"
      class="close dynamic-modal-close"
      aria-label="Close"
      (click)="activeModal.dismiss('Close Button')"
      icon="times"
      size="large"
    ></aurora-icon-button>
    <ep-dynamic-content [type]="type" [dynamicData]="dynamicData"></ep-dynamic-content>
    <div *ngIf="showOKButton" class="modal-footer">
      <aurora-button variant="primary" type="button" (click)="activeModal.dismiss('Close Button')">OK</aurora-button>
    </div>
  `
})
export class DynamicContentModalComponent {
    @Input()
    type: string;

    @Input()
    dynamicData: any;

    @Input()
    injector: Injector;

    @Input()
    showCloseButton: boolean = true;

    @Input()
    showOKButton: boolean = false;

    constructor(public activeModal: NgbActiveModal) { }
}
